var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon=home-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 17.5001V11.3334C8 10.8667 8 10.6334 8.09083 10.4551C8.17072 10.2983 8.29821 10.1708 8.45501 10.0909C8.63327 10.0001 8.86662 10.0001 9.33333 10.0001H11.6667C12.1334 10.0001 12.3667 10.0001 12.545 10.0909C12.7018 10.1708 12.8293 10.2983 12.9092 10.4551C13 10.6334 13 10.8667 13 11.3334V17.5001M9.68141 2.30345L4.02949 6.69939C3.65168 6.99324 3.46278 7.14017 3.32669 7.32417C3.20614 7.48716 3.11633 7.67077 3.06169 7.866C3 8.08639 3 8.3257 3 8.80433V14.8334C3 15.7669 3 16.2336 3.18166 16.5901C3.34144 16.9037 3.59641 17.1587 3.91002 17.3185C4.26654 17.5001 4.73325 17.5001 5.66667 17.5001H15.3333C16.2668 17.5001 16.7335 17.5001 17.09 17.3185C17.4036 17.1587 17.6586 16.9037 17.8183 16.5901C18 16.2336 18 15.7669 18 14.8334V8.80433C18 8.3257 18 8.08639 17.9383 7.866C17.8837 7.67077 17.7939 7.48716 17.6733 7.32417C17.5372 7.14017 17.3483 6.99324 16.9705 6.69939L11.3186 2.30345C11.0258 2.07574 10.8794 1.96189 10.7178 1.91812C10.5752 1.87951 10.4248 1.87951 10.2822 1.91812C10.1206 1.96189 9.97418 2.07574 9.68141 2.30345Z",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/iconHome.8a2b6481129f66337956f8430e661208.svg";
export { ForwardRef as ReactComponent };